var map = {
	"./ACTIVITIES.svg": 1608,
	"./BABY_CHILD_CARE.svg": 1609,
	"./BEACH_FRONT.svg": 1610,
	"./BUSINESS_SERVICE.svg": 1611,
	"./COMFORT_HOTEL.svg": 1612,
	"./COMFORT_ROOM.svg": 1613,
	"./COMMUNICATIONS.svg": 1614,
	"./ENTERTAINMENT.svg": 1615,
	"./FINANCIAL_SERVICES.svg": 1616,
	"./FOOD_DRINKS.svg": 1617,
	"./HEALTH_BEAUTY.svg": 1618,
	"./SHOPPING.svg": 1619,
	"./SPORT.svg": 1620,
	"./TRANSPORTATION.svg": 1621,
	"./flight.svg": 1622,
	"./food.svg": 1623,
	"./hotel.svg": 1624,
	"./kids.svg": 1625,
	"./room.svg": 1626,
	"./score/flight.svg": 1015,
	"./score/food.svg": 1016,
	"./score/hotel.svg": 1017,
	"./score/kids.svg": 1018,
	"./score/room.svg": 1019,
	"./totalscore.svg": 1020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1607;